<template>
  <md-dialog
    :id="refName"
    :ref="refName"
    :md-esc-to-close="false"
    :md-click-outside-to-close="false"
    :class="size"
    class="question standard-modal"
  >
    <md-dialog-title>
      <div
        v-if="!hideTitle"
        class="standard-modal__title"
        :class="{'clickable': headerClickable}"
        @click="headerAction"
      >
        <svg-loader
          v-if="iconEnabled"
          :src="icons[iconType]"
        />
        {{ title }}
      </div>
      <button
        v-if="closeButtonEnabled"
        class="close-button btn-transparent"
        @click="close()"
      >
        <md-icon>clear</md-icon>
      </button>
    </md-dialog-title>

    <md-dialog-content>
      <div class="standard-modal__description">
        <slot />
      </div>

      <div
        v-if="buttonsEnabled"
        class="standard-modal__container-cta"
      >
        <md-button
          v-if="!hideFirstButton"
          :class="[{'button-with-subtext': firstButtonSubText,
                    'center': hideSecondButton}, firstButtonStyle]"
          :disabled="firstButtonDisabled"
          class="btn standard-modal__container-cta__button"
          @click="firstButtonAction()"
        >
          <span v-if="firstButtonText">{{ firstButtonText }}</span>
          <span v-if="firstButtonSubText">{{ firstButtonSubText }}</span>
        </md-button>
        <md-button
          v-if="!hideSecondButton"
          :class="[{'button-with-subtext': secondButtonSubText,
                    'center': hideFirstButton}, secondButtonStyle]"
          :disabled="secondButtonDisabled"
          class="btn standard-modal__container-cta__button"
          @click="secondButtonAction()"
        >
          <span v-if="secondButtonText">{{ secondButtonText }}</span>
          <span v-if="secondButtonSubText">{{ secondButtonSubText }}</span>
        </md-button>
      </div>

      <attention-box
        v-if="warningEnabled"
        width="full-size"
      >
        <span v-html="warningText" />
        <span
          v-if="warningAction"
          class="hyper-link"
          @click="warningEvent()"
        >{{ warningAction }}</span>.
      </attention-box>

      <div
        v-if="!hideDismissLink"
        class="standard-modal__container-dismiss"
      >
        <md-button
          :disabled="dismissDisabled"
          class="btn btn-dismiss-purple center"
          @click="dismissAction()"
        >
          {{ dismissText }}
        </md-button>
      </div>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import mixin from './../modalMixin'

export default {
  name: 'ModalQuestion',
  mixins: [mixin]
}
</script>

<style lang="scss" scoped>
.question {
  .standard-modal {
    &__title {
      .md-icon {
        min-width: auto;
        width: 17px;
        height: 16px;
        min-height: auto;
        margin: 2px 7px 0 0;
      }
    }
  }
  .close-button {
    position: absolute;
    top: 23px;
    right: 38px;
  }

  p {
    font-size: 15px;
    text-align: left;
    letter-spacing: -0.2px;
    color: #303030;
    margin-bottom: 10px;
  }

  .center {
    margin: auto;
  }

  .button-with-subtext {
    height: auto;
    line-height: normal;
    font-size: 16px;
    font-family: Roboto, sans-serif;
    padding: 10px 10px;

    span {
      text-transform: initial;
      display: block;
      white-space: normal;
      line-height: normal;
      font-weight: 400;
      font-size: 13px;
    }
  }
}
</style>
